// extracted by mini-css-extract-plugin
module.exports = {"root":"Section_root__1VyOV","label":"Section_label__3ZOLf","contentWrap":"Section_contentWrap__y4y4_","footer":"Section_footer__F74I1","footerInner":"Section_footerInner__BDLHN"};